import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHogTracking } from '../hooks/usePostHogTracking';

const PageViewTracker = () => {
  const location = useLocation();
  const { trackPageView } = usePostHogTracking();

  useEffect(() => {
    // Map paths to readable page names
    const getPageName = (pathname) => {
      switch (pathname) {
        case '/':
          return 'home';
        case '/reviews':
          return 'reviews';
        case '/newsletter':
          return 'newsletter';
        case '/notifications':
          return 'notifications';
        case '/admin':
          return 'admin';
        default:
          return '404';
      }
    };

    const pageName = getPageName(location.pathname);
    trackPageView(pageName, {
      path: location.pathname,
      search: location.search,
      hash: location.hash
    });
  }, [location, trackPageView]);

  return null; // This component doesn't render anything
};

export default PageViewTracker;
